module.exports = __webpack_public_path__ + "img/img_footer.93aeb346.png";